import React from "react";
import { useAuth } from "src/providers/AuthProvider";
import AppNavbar from "./AppNavbar";
import MarketingNavbar from "./MarketingNavbar";

export default function Navbar() {
  const { status } = useAuth();

  return status === "authenticated" ? <AppNavbar /> : <MarketingNavbar />;
}
